import { Component, OnInit } from '@angular/core';
import { ChartDataSets, ChartType, ChartOptions } from 'chart.js';
import { Label } from 'ng2-charts';
import { ReportService } from 'src/app/services/report.service';
import { Subscription } from 'rxjs';
import { StorageMap } from '@ngx-pwa/local-storage';

@Component({
  selector: 'app-report-proposal-categories',
  templateUrl: './report-proposal-categories.component.html',
  styleUrls: ['./report-proposal-categories.component.css']
})

export class ReportProposalCategoriesComponent implements OnInit{

  constructor(private storage: StorageMap, private reportService: ReportService) { }
  dataSubscription: Subscription;
  labels: string[];
  categoriesSum: number[];
  chartOptions: ChartOptions = {
    responsive: true,
  };
  tracks: Label[];
  chartType: ChartType = 'pie';
  chartLegend = true;
  chartPlugins = [];
  chartData: ChartDataSets[] = [];
  hasData = false;

  ngOnInit(): void {
    this.dataSubscription = this.storage.watch('selectedOpenId', { type: 'string' })
      .subscribe((openId) => {
        const openIdInt = parseInt(openId, 10);
        if (!isNaN(openIdInt)){
          this.getTracksParticipantVsVoters(openIdInt);
        }
      });
  }

  getTracksParticipantVsVoters(openSpaceId) {
    this.reportService.proposalByCateory(openSpaceId)
      .subscribe(data => {
        if (data && data.Reports.length !== 0){
          this.tracks = data.Reports[0].labels;
          this.chartData = data.Reports[0].data;
          this.hasData = true;
          }
      },
      error => {
        console.error(error);
      });
  }
}


